import LandingV2App from './components/landing/landing-v2/App'

export default function App() {
  return <LandingV2App />
}